import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const authApi = createApi({
  reducerPath: "auth",
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (login) => ({
        url: `/auth/login`,
        method: "POST",
        body: login,
      }),
    }),

    register: builder.mutation({
      query: (register) => ({
        url: `/auth/register`,
        method: "POST",
        body: register,
      }),

    }),

    changePassword: builder.mutation({
      query: (data) => ({
        url: `/auth/change-password`,
        method: "POST",
        body: data,
      }),
    }),

    verifyEmail: builder.mutation({
      query: (data) => ({
        url: `/auth/verify`,
        method: "POST",
        body: data,
      }),
    }),
    verifyOTP: builder.mutation({
      query: (data) => ({
        url: `/auth/verify-otp/email`,
        method: "POST",
        body: data,
      }),
    }),
    resendOTP: builder.mutation({
      query: (data) => ({
        url: `/auth/resend-otp/email`,
        method: "POST",
        body: data,
      }),
    }),
    updateProfile: builder.mutation({
      query: (data) => ({
        url: `/users/profile`,
        method: "PUT",
        body: data,
      }),
    }),
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: `/auth/forgotpassword`,
        method: "POST",
        body: data,
      }),
    }),
    adminLogin: builder.mutation({
      query: ({ token, user }) => ({
        url: `/auth/login`,
        method: "POST",
        body: user,
        headers: {
          'x-admin-access-token': `${token}`,
          'Content-Type': 'application/json',
        },
      }),
    }),
    deleteAccount: builder.mutation({
      query: () => ({
        url: `/auth/delete-account`,
        method: "DELETE",
      }),
    }),
    getUserProfile: builder.query({
      query: () => ({
        url: `/users/profile`,
        method: "GET",
      }),
      transformResponse: (response) => {
        return response.data;
      }
    }),
    logout: builder.mutation({
      query: (data) => ({
        url: `/auth/logout`,
        method: "POST",
        body: data,
      }),
    }),
    newPassword: builder.mutation({
      query: (data) => ({
        url: `/auth/reset-password`,
        method: "POST",
        body: data,
      }),
    }),
    checkEmail: builder.mutation({
      query: (data) => ({
        url: `/auth/check-email`,
        method: "POST",
        body: data,
      }),
    }),

  }),
});

export const {
  useForgotPasswordMutation,
  useLoginMutation,
  useRegisterMutation,
  useChangePasswordMutation,
  useVerifyEmailMutation,
  useVerifyOTPMutation,
  useAdminLoginMutation,
  useUpdateProfileMutation,
  useResendOTPMutation,
  useDeleteAccountMutation,
  useGetUserProfileQuery,
  useLogoutMutation,
  useNewPasswordMutation,
  useCheckEmailMutation,
} = authApi;